import { render, staticRenderFns } from "./presDeliveryTableHead.vue?vue&type=template&id=3fd2c4f7&scoped=true&"
import script from "./presDeliveryTableHead.vue?vue&type=script&lang=js&"
export * from "./presDeliveryTableHead.vue?vue&type=script&lang=js&"
import style0 from "./presDeliveryTableHead.vue?vue&type=style&index=0&lang=css&"
import style1 from "./presDeliveryTableHead.vue?vue&type=style&index=1&id=3fd2c4f7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fd2c4f7",
  null
  
)

export default component.exports